import { render, staticRenderFns } from "./PlatformCompare.vue?vue&type=template&id=47e503b7&scoped=true"
import script from "./PlatformCompare.vue?vue&type=script&lang=js"
export * from "./PlatformCompare.vue?vue&type=script&lang=js"
import style0 from "./PlatformCompare.vue?vue&type=style&index=0&id=47e503b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e503b7",
  null
  
)

export default component.exports